import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface HostEvent {
  readonly name: 'back-to-email';
  readonly from: 'authenticate' | 'vehicle-selection' | 'license-plate-search';
}

@Injectable({ providedIn: 'root' })
export class HostEventService {
  private readonly emitted = new Subject<HostEvent>();

  public readonly events: Observable<HostEvent> = this.emitted.asObservable();

  public emit(event: HostEvent): void {
    this.emitted.next(event);
  }
}
